import { render, staticRenderFns } from "./UIBooleanRadioButtons.vue?vue&type=template&id=27a63f70&"
import script from "./UIBooleanRadioButtons.vue?vue&type=script&lang=js&"
export * from "./UIBooleanRadioButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports